import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../icon';

function MenuControls(props) {
	const {
		isMaximized,
		onMaximizeClick,
		onMinimizeClick
	} = props;

	const icon = isMaximized ? 'chevronLeft' : 'chevronRight';

	const handleClick = () => {
		isMaximized ? onMinimizeClick() : onMaximizeClick();
	};

	return (
		<div className="flex items-center justify-end">
			<Icon
				use={icon}
				color="white"
				className="opacity-50 hover:opacity-100 cursor-pointer"
				style={{ margin: '1.25rem 1.5rem' }}
				onClick={handleClick}
			/>
		</div>
	);
}

MenuControls.propTypes = {
	isMaximized: PropTypes.bool,
	onMaximizeClick: PropTypes.func,
	onMinimizeClick: PropTypes.func
};

MenuControls.methodProps = [
	'onMaximizeClick',
	'onMinimizeClick'
];

export default MenuControls;
